import IUser from './User'

export type IAuth = {
  code?: string
  email?: string
  password: string
  confirmPassword?: string
  resetPasswordToken?: string
}

export type IAuthResponse = {
  token: string
  refreshToken: string
  user: IUser
}

export const AuthInitialValue: IAuth = {
  email: '',
  confirmPassword: '',
  password: '',
  resetPasswordToken: '',
}
